import { ADD_NOTICE } from './constants';

// The initial state of this store.
const initialState = {
    data: null,
};

export { initialState };

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_NOTICE: {
            return {
                ...state,
                data: action.data,
            };
        }

        default: {
            return state;
        }
    }
};
